import { useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

export function ButtonValueSelect(props) {
	let { options, bindAttribute, bindObject, onChange, defaultValue, saveAction, ...passableProps } = props;
	let detectedValue = defaultValue;
	if(bindObject != null) {
		detectedValue = bindObject[bindAttribute];
	}
	let [initialValue, setInitialValue] = useState(detectedValue);
	if(detectedValue != initialValue) {
		setInitialValue(detectedValue);
	}

	let updateValue = (val) => () => {
		if(bindObject != null) {
			bindObject[bindAttribute] = val;
		}
		setInitialValue(val);
		onChange?.(val);
		saveAction?.();
    };

	return (
		<ButtonGroup {...passableProps}>
			{options.map((info, idx) => <Button variant={initialValue == info[1] ? info[2] : info[3]} key={info[1]} className={initialValue == info[1] ? `active` : ``} onClick={updateValue(info[1])}>
				{info[0]}
			</Button>)}
		</ButtonGroup>
	);

}